// export const API = "https://api.dev.food.delivery.tdrsoftware.in"
const Id = localStorage.getItem("adminId")

export const API = `https://api.surajrestaurant.in/${Id}`;
